import {setNatomasUser} from "./UsersService";

export const savePayloadToCustomer = async (id: string, payload: any) => {
  if (!id || !payload) return;
  return setNatomasUser(id, {...payload, user_id: id});
};
